import { Routes } from '@angular/router';
import { authGuard } from './guard/auth.guard';

export const routes: Routes = [
    {
        path: '', redirectTo: '/login', pathMatch: "full"
    },
    {
        path: 'login',
        loadComponent: ()=> import('./screens/accounts/login/login.component').then((c)=>c.LoginComponent),
        title:'Login'
    },
    {
        path: '2fa',
        loadComponent: () => import('./screens/accounts/two-fa/two-fa.component').then((c) => c.TwoFAComponent),
        title: '2FA'
    },
    {
        path: 'forgotPassword',
        loadComponent:()=>import('./screens/accounts/forgot-password/forgot-password.component').then(c=>c.ForgotPasswordComponent),
        title:'Forgot Password'
    },
    {
        path:'activateaccount',
        loadComponent:()=>import('./screens/accounts/activate-account/activate-account.component').then(c=>c.ActivateAccountComponent),
        title:'Activate Account'
    },
    {
        path: 'resetpassword',
        loadComponent:()=>import('./screens/accounts/reset-password/reset-password.component').then(c=>c.ResetPasswordComponent),
        title:'Reset Password'
    },
    {
        path: 'dashboard',
        loadChildren:()=>import('./screens/dashboard.routes').then(c=>c.routes),
        title:'Dashboard',
        data:{preload:true},
        canActivate: [authGuard]
    },
    {
        path: 'webpayment',
        loadChildren: () => import('./screens/webpayment-routes').then(c => c.WebPaymentRoutes),
        title: 'Web payments',
    },
    {
        path: '**', redirectTo: '/login', pathMatch: "full"
    }
];
